import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckForgotToken } from "../Api/UserOperations/CheckForgotToken";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { UpdatePassword } from "../Api/UserOperations/UpdatePassword";

const ResetPassword = () => {
  const query = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [userID, setUserID] = useState("");

  const checkPasswordToken = async () => {
    const { data } = await CheckForgotToken(query);

    const Toast = Swal.mixin({
      toast: true,
      position: "bottom",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    Toast.fire({
      icon: data.status ? "success" : "error",
      title: `${data.msg}`,
    });
    data.status && setUserID(data.userID);
    !data.status ? navigate("/") : setData(data.status);
  };

  useEffect(() => {
    checkPasswordToken();
    //eslint-disable-next-line
  }, []);

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } = useFormik({
    initialValues: {
      Password: "",
      PasswordConfirm: "",
    },
    validationSchema: Yup.object({
      Password: Yup.string().required("Password is required"),
      PasswordConfirm: Yup.string().oneOf([Yup.ref("Password"), null], "Passwords must match"),
    }),
    onSubmit: async (values) => {
      const { data } = await UpdatePassword(values, userID);

      if (data.status) {
        Swal.fire("Password Change successfull!", `${data.msg}`, "success");
        setTimeout(() => {
          navigate("/Login");
        }, 500);
      } else {
        Swal.fire("Password Change Failed!", `${data.msg}`, "error");
      }
    },
  });

  return (
    <>
      {data && (
        <div>
          <section className="h-auto mx-auto max-w-screen-xl px-4">
            <div className="px-6 h-auto text-gray-800">
              <div className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6">
                <div className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0">
                  <img
                    src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                    className="w-full"
                    alt="Make Money Login"
                  />
                </div>
                <div className="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-6">
                      <input
                        onChange={handleChange}
                        value={values.Password}
                        onBlur={handleBlur}
                        name="Password"
                        type="password"
                        className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        placeholder="New Password"
                      />
                      {touched.Password && errors.Password && (
                        <span className="text-red-500 py-2">{errors.Password}</span>
                      )}
                    </div>

                    <div className="mb-6">
                      <input
                        onChange={handleChange}
                        value={values.PasswordConfirm}
                        onBlur={handleBlur}
                        name="PasswordConfirm"
                        type="password"
                        className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        placeholder="New Password Confirm"
                      />
                      {touched.PasswordConfirm && errors.PasswordConfirm && (
                        <span className="text-red-500 py-2">{errors.PasswordConfirm}</span>
                      )}
                    </div>

                    <div className="text-center lg:text-left">
                      <button
                        type="submit"
                        className="inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                      >
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};
export default ResetPassword;
